import React from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select'

const CampusSearch = ({onChange,loadOptions,value}) => {
  return (
    <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12" style={{zIndex:'4'}}>
      <label htmlFor="campus">Campus</label>
      <Select.Async
        id="campus"
        value={value} valueKey="DEPTID" labelKey="CAMPUS"
        onChange={onChange} loadOptions={loadOptions}
      />
    </div>
  )
};

CampusSearch.propTypes = {
  value: PropTypes.object,
  loadOptions: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired
};
CampusSearch.defaultProps = {};

export default CampusSearch;


// WEBPACK FOOTER //
// ./src/components/CampusSearch.jsx